

export const setSearchParam = ( key, value ) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams( queryString );
    urlParams.set( key, value );
    window.history.replaceState( { key: value }, `${ key }: ${ value }`, `${ window.location.pathname }?${ urlParams.toString() }` );
};

const getSearchParam = ( key ) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams( queryString );
    return urlParams.get( key );
};

const deleteSearchParam = ( key ) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams( queryString );
    urlParams.delete( key );
    window.history.replaceState( { key: '' }, `${ key }: ''`, urlParams.toString() === '' ? window.location.pathname : `${ window.location.pathname }?${ urlParams.toString() }` );
};

export const getParams = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams( queryString );
    const ret = {};
    urlParams.forEach( ( val, key ) => {
        ret[ key ] = val;
    } );

    return ret;
};

export const setParams = ( obj ) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams( queryString );


    Object.keys( obj ).forEach( key => {
        if ( [ null, undefined ].includes( obj[ key ] ) ) {return;}
        urlParams.set( key, obj[ key ] );
    } );

    window.history.replaceState( obj, `${ obj }`, `${ window.location.pathname }?${ urlParams.toString() }` );
};

/* PAGE NUMBER */

const pageKey = 'page';

export const setPageNumber = ( page ) => setSearchParam( pageKey, page );

export const getPageNumber = () => {
    const pn = getSearchParam( pageKey );
    let page = isNaN( pn ) || pn == null ? 1 : parseInt( pn );
    if ( page < 1 ) {
        page = 1;
    }
    return page;
};

/* SEARCH VALUE */

const searchKey = 'search';

export const setSearchValue = ( search ) => {
    if ( !search ) {
        deleteSearchParam( searchKey );
    }
    else {
        setSearchParam( searchKey, search );
    }
};

export const getSearchValue = () => getSearchParam( searchKey );